<template>
    <div class="layout-plan" :class="planClasses">
        <div class="flex items-center justify-between gap-x-4">
            <h3 class="text-lg font-semibold text-white">
                {{ plan.subscription_plan_name }}
            </h3>
            <div class="rounded-full bg-sky-700 px-2.5 py-1 text-center text-xs font-semibold text-white" v-if="savePercent">
                Save {{ savePercent }}%
            </div>
        </div>
        <p class="mt-1 text-sm leading-6 text-white" v-if="priceText">
            {{ priceText }}
        </p>
        <p class="mt-4 flex items-baseline gap-x-1">
            <span class="text-4xl font-bold tracking-tight text-white">
                {{ priceCurrency(plan.subscription_plan_amount) }}
            </span>
            <span class="text-sm font-semibold leading-6 text-white">
                / {{ plan.subscription_plan_interval }}
            </span>
        </p>
        <ButtonBlock
            class="mt-5"
            buttonText="Select Plan"
            :buttonClick="selectPlan"
            :buttonClickParams="plan"
        ></ButtonBlock>
        <ArticleMembershipSellingPoints textSize="text-sm" />
    </div>
</template>

<script>
export default {
    name: 'LayoutPlan',
    props: {
        plan: {
            required: true,
            type: Object,
            default () {
                return {};
            },
        },
        plans: {
            required: true,
            type: Array,
            default () {
                return [];
            },
        },
    },
    emits: ['selectPlan'],
    computed: {
        planClasses () {
            const cls = {};
            cls['rounded-3xl p-7'] = true;
            cls['bg-zinc-900 text-white ring-1 ring-zinc-600'] = true;
            return cls;
        },
        savePercent () {
            return this.plan.subscription_plan_interval === 'year' ? this.annualSaving : null;
        },
        annualSaving () {
            let monthly = null;
            let yearly = null;
            this.plans.map((plan) => {
                if (plan.subscription_plan_interval === 'month') monthly = plan.subscription_plan_amount;
                if (plan.subscription_plan_interval === 'year') yearly = plan.subscription_plan_amount;
                return true;
            });
            if (!monthly || !yearly) return null;
            let saving = ((monthly - (yearly / 12)) / monthly) * 100;
            return Math.round(saving);
        },
        priceText () {
            if (this.plan.subscription_plan_interval === 'year') {
                let monthly = this.plan.subscription_plan_amount / 12;
                return 'Works out at ' + this.priceCurrency(monthly) + ' per Month';
            }
            return 'Stay Flexible';
        },
    },
    methods: {
        selectPlan (plan) {
            this.$emit('selectPlan', plan);
        },
        priceCurrency (number) {
            return useUtilityFunctions().formatCurrency(number);
        },
    },
};
</script>
